import React from "react";
import { Routes, Route } from "react-router-dom";

import List from "./list";
import Workshop from "./workshop";

export default function Learn() {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:id" element={<Workshop />} />
    </Routes>
  );
}
